import type { History } from 'history'

export const OAUTH_IFRAME_MESSAGE_TYPE = 'simplesat-oauth-complete'

type OAuthIframeCompletionOptions = {
  pathname?: string
  search?: string
  state?: unknown
  token?: string
}

type OAuthIframeCompletionNavigateOptions = OAuthIframeCompletionOptions & {
  replace?: boolean
}

const hasSameOriginOpener = () => {
  const opener = window.opener

  if (!opener || opener.closed) {
    return false
  }

  try {
    return opener.location.origin === window.location.origin
  } catch {
    return false
  }
}

export const completeOAuthInOpener = ({
  pathname = '/',
  search = '',
  state,
  token,
}: OAuthIframeCompletionOptions = {}) => {
  if (!hasSameOriginOpener()) {
    return false
  }

  window.opener.postMessage(
    {
      type: OAUTH_IFRAME_MESSAGE_TYPE,
      pathname,
      search,
      state,
      token,
    },
    window.location.origin
  )
  window.close()
  return true
}

export const completeOAuthInOpenerOrNavigate = (
  history: History,
  {
    pathname = '/',
    search = '',
    state,
    token,
    replace = false,
  }: OAuthIframeCompletionNavigateOptions = {}
) => {
  if (completeOAuthInOpener({ pathname, search, state, token })) {
    return true
  }

  const navigate = replace ? history.replace : history.push
  navigate({ pathname, search, state })
  return false
}



// WEBPACK FOOTER //
// ./src/libs/oauthIframeBridge.ts